<p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
<div class="card bg-light">
    <div class="card-body">
        <div class="form-row">
            <label for="txtNameLast" class="col-sm-1 col-form-label prd-label">Name</label>
            <input id="txtNameLast" placeholder="Last, First MI"  [(ngModel)]='applicant.name' class="form-control col-sm-3" (change)='dataChange()' maxlength="80">  &nbsp; &nbsp;
            <button (click)="getApplicantList()" title="Search your database for a matching Applicant" class="btn btn-info btn-sm">Find Applicant</button>
            <button (click)="getLastApplicant()" title="Get the LAST applicant saved by you." class="offset-1 btn btn-outline-secondary btn-sm" *ngIf="bHasPrevApplicant">Get Last Applicant</button>
        </div>
        <div class="card" style="margin: 10px;" *ngIf="applicantList?.length > 0">
            <button (click)="clearApplicantList()" title="Click to clear list of matching Applicants (below)" class="btn btn-sm btn-info">Clear List</button>
            <hr />
            <p-table [value]="applicantList" [scrollable]="true" scrollHeight="520px" styleClass="p-datatable-striped p-datatable-sm" >
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of cols; let i = index" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon *ngIf="i>0" field="{{col.field}}"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-applicant>
                    <tr style="font-size: small">
                        <td>
                            <button class="btn btn-link" (click)="applicantSelected(applicant)"> Select </button>
                        </td>
                        <td>{{ applicant.name }}</td>
                        <td>{{ applicant.strAddr}}</td>
                        <td>{{ applicant.city }}</td>
                        <td>{{ applicant.state }}</td>
                        <td>{{ applicant.phone}}</td>
                        <td>{{ applicant.email }}</td>
                    </tr>
                </ng-template>
                <ng-template *ngIf="applicantList" pTemplate="summary">
                    <div class="row">
                        <div class="col-md-2 offset-1" style="text-align: left;"># of matches: {{ applicantList.length }}</div>
                    </div>
                </ng-template>
            </p-table>
            <br />
        </div>
        <br />
        <div *ngIf="!applicantList?.length"> <!-- hide if showing list from lookup-->
            <div class="form-row">
                <label for="txtEmail" class="col-sm-1 col-form-label prd-label">E-mail</label>
                <input id="txtEmail" [(ngModel)]='applicant.email' class="form-control col-sm-3" (change)='dataChange()'>
                <label for="txtPhone" class="col-sm-1 col-form-label prd-label">Phone</label>
                <input id="txtPhone" [(ngModel)]='applicant.phone' class="form-control col-sm-2" (change)='dataChange()'>
                <label for="txtAltPhone" class="col-sm-1 col-form-label prd-label">Alt Phone</label>
                <!--<p-inputMask [(ngModel)]="applicant.altPhone" mask="(999) 999-9999? x999" unmask="true" autoClear="false" (change)='dataChange()'></p-inputMask>-->
                <input id="txtAltPhone" placeholder="Alt Phone" [(ngModel)]='applicant.altPhone' class="form-control col-sm-1 prd-small" (change)='dataChange()'>
                <label for="txtFax" class="col-sm-1 col-form-label prd-label">Fax #</label>
                <input id="txtFax" [(ngModel)]='applicant.fax' class="form-control col-sm-1 prd-small" (change)='dataChange()'>
            </div>
            <br />
            <div class="form-row">
                <label for="txtAddress" class="col-sm-1 col-form-label prd-label">Address</label>
                <input id="txtAddress" [(ngModel)]='applicant.strAddr' class="form-control col-sm-3" (change)='dataChange()' maxlength="100">
                <label for="txtCity" class="col-sm-1 col-form-label prd-label">City</label>
                <input id="txtCity" [(ngModel)]='applicant.city' class="form-control col-sm-2" (change)='dataChange()' maxlength="50">
                <label for="txtState" class="col-sm-1 col-form-label prd-label">State</label>
                <input id="txtState" [(ngModel)]='applicant.state' class="form-control col-sm-1 prd-small" (change)='dataChange()' maxlength="2">
                <label for="txtZip" class="col-sm-1 col-form-label prd-label">Zip</label>
                <input id="txtZip" [(ngModel)]='applicant.zip' class="form-control col-sm-1 prd-small" (change)='dataChange()' maxlength="10" >
            </div>
            <br />
            <div class="form-row">
                <label for="chkSigVerify" class="col-sm-1 col-form-label prd-label">Original Signature Verified</label>
                <input id="chkSigVerify" type="checkbox" [(ngModel)]='applicant.sign' class="form-control col-sm-2" (change)='dataChange()'>
                <label for="cmbApplicantType" class="col-sm-1 col-form-label prd-label">Applicant Type</label>
                <select id="cmbApplicantType" class="form-control col-sm-3" [(ngModel)]='applicant.type' (change)='dataChange()'>
                    <option></option>
                    <option *ngFor="let appType of applicantTypeList">{{appType}}</option>
                </select>
                <label for="chkNotNotarized" class="col-sm-2 offset-1 col-form-label prd-label">Executed Outside CA and not Notarized</label>
                <input id="chkNotNotarized" type="checkbox" [(ngModel)]='applicant.notNotarized' class="form-control col-sm-1" (change)='dataChange()'>
            </div>
        </div>
    </div>
</div>

